import {axios, API, SendRequest} from '@/imports-files/pages/clients/jobs/job-sharing';

export class JobSharing extends SendRequest {
  
  // async getJobBoards(client_auth_cookies, jobId) {
  //   try {
  //     const result = await axios({
  //       method: 'get',
  //       url: API.client.jobs.GET_JOB_BOARDS.replace('$job_id', jobId),
  //       headers: {cookie: `Authorization=${client_auth_cookies}`},
  //       params: {},
  //     });
  //     return result.data;
  //   } catch (error) {
  //     return error;
  //   }
  // }

  async getJobBoards(jobId) {
    try {
      const result = await axios.get(API.client.jobs.GET_JOB_BOARDS.replace('$job_id', jobId),
          {
            headers: this.customHeaderJSON()
          },
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async addJobBoards(params, jobId)
  {
    try {
      const result = await axios.post(API.client.jobs.ADD_JOB_BOARDS.replace('$job_id', jobId),
          params,
          this.setHeaderJSON(),
          this.setCrossDomainTrue(),
          this.setCredentialsJSON());
      return result;
    } catch (error) {
      return error;
    }
  }

  async getUserByNameOrEmail(params) {
    try {
      const result = await axios.get( API.client.jobs.GET_AGENCY_USERS,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    } 
    catch (error) {
      return error;
    }
  }

  async getAgencyOrClientUserByNameOrEmail(params) {
    try {
      const result = await axios.get( API.client.jobs.GET_SHARE_USERS,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }

  async checkAgencyUserExist(params) {
    try {
      const result = await axios.get( API.client.jobs.CHECK_AGENCY_USER_EXIST,
        {
          params: params,
          headers: this.customHeaderJSON()
        },
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }

  async addAgencyUserResponse(params, jobId){
    try {
      const result = await axios.post( API.client.jobs.ADD_AGENCY_USER_RESPONSE.replace('$job_id', jobId),
        params,
        this.setHeaderJSON(),
        this.setCrossDomainTrue(),
        this.setCredentialsJSON());
      return result;
    }
    catch (error) {
      return error;
    }
  }
}